import { render, staticRenderFns } from "./CreateBookingSlot.vue?vue&type=template&id=d88bf72e&scoped=true&"
import script from "./CreateBookingSlot.vue?vue&type=script&lang=js&"
export * from "./CreateBookingSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88bf72e",
  null
  
)

export default component.exports